import { FirebaseApp, FirebaseOptions, getApp, getApps, initializeApp } from 'firebase/app';
import { Database, getDatabase } from 'firebase/database';
import { Auth, getAuth } from 'firebase/auth';
import { FirebaseStorage, getStorage } from 'firebase/storage';
import { Firestore, getFirestore } from 'firebase/firestore';
import { Functions, getFunctions } from 'firebase/functions';

const firebaseConfig: FirebaseOptions = {
  apiKey: 'AIzaSyA0d7hCAPqRhONRYV-VgsJ4zfqaC3QJO_E',
  authDomain: 'healthy-pet-80850.firebaseapp.com',
  databaseURL: 'https://healthy-pet-80850-default-rtdb.firebaseio.com/',
  projectId: 'healthy-pet-80850',
  storageBucket: 'healthy-pet-80850.firebasestorage.app',
  messagingSenderId: '820643325933',
  appId: '1:820643325933:web:de6402b65b3915b5c2e9e4',
};

const existingApps = getApps();
const app: FirebaseApp = existingApps.length ? getApp() : initializeApp(firebaseConfig);
const database: Database = getDatabase(app);
const auth: Auth = getAuth(app);
const storage: FirebaseStorage = getStorage(app);
const firestore: Firestore = getFirestore(app);
const functions: Functions = getFunctions(app, 'us-central1');

export { app, database, auth, storage, firestore, functions };
